import ClearingAPI from '@shared/api';

export const {
    userManagement: { getByUsername: getByUsername },
} = ClearingAPI.settings;
